/**
 * The page is a day: scroll position is the hour. 0 = noon (top of the page),
 * 1 = the Sun has set (bottom). Read by the scene every frame; no React involved.
 */
export function readDay(): number {
  const doc = document.documentElement
  const max = doc.scrollHeight - window.innerHeight
  if (max <= 0) return 0
  return Math.min(1, Math.max(0, window.scrollY / max))
}

/**
 * Where the Sun is at a given hour. `aspect` is width / height: in portrait
 * the Sun is sized by width instead of height, starts higher so the name at
 * the bottom stays clear of it, and sets more or less straight down.
 */
export function sunAt(
  day: number,
  aspect: number,
): { center: [number, number]; radius: number; dusk: number } {
  const e = day * day * (3 - 2 * day) // smoothstep
  const portrait = aspect < 0.8
  const radius = Math.min(0.31 + 0.24 * e, (0.3 + 0.09 * e) * aspect)
  return {
    center: portrait ? [0.5 + 0.08 * e, 0.34 + 1.0 * e] : [0.5 + 0.26 * e, 0.52 + 0.82 * e],
    radius,
    dusk: Math.min(1, day * 1.25),
  }
}
